<div class="padding-left-30 margin-top-50">
    <h1>Forwarding to back office shortly...<i
            style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
            class="fa fa-spinner fa-spin"></i></h1>
</div>